import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiUxService } from './api-ux/api-ux.service';

@Injectable({
  providedIn: 'root'
})
export class ZendeskService {

  private readonly UrlLabels: { url: string, label: string }[] = [
    { url: '/home', label: 'accueil' },
    { url: '/administratif/factures/historique', label: 'histoFactures' },
    { url: '/administratif/factures', label: 'validerFactures' },
    { url: '/administratif/generer-contrats', label: 'Contrats' },
    { url: '/administratif/transferer-investisseur', label: 'TransférerInv' },
    { url: '/administratif/gerer-statut-cif', label: 'CIF' },
    { url: '/investisseurs/ariane', label: 'ariane' },
    { url: '/investisseurs/documents-r%C3%A9glementaires', label: 'docReglementaire' },
    { url: '/rapports/v2/challenges-classements', label: 'Challenge' },
    { url: '/rapports/v2/commissions-primes', label: 'Commissions' },
    { url: '/rapports/v2/pilotage-organisation', label: 'Organisation' },
    { url: '/rapports/v2/qualification-titre', label: 'QualificationTitre' },
    { url: '/rapports/v2/va-organisation', label: 'VAOrganisation' },
    { url: '/rapports/v2/va-personnel', label: 'VAPersonnel' },
    { url: '/rapports/v2/dons-programme-finzzact', label: 'DonsFinzzact' },
    { url: '/developpement-animation/finzzact', label: 'Finzzact' },

  ];


  constructor(
    private apiService: ApiUxService,
  ) { }

  async redirectToZendesk(zendeskUri: string, newTab: boolean) {


    const token = await this.getToken();
    newTab ? window.open(`${environment.zendesk.url}access/jwt?jwt=${token}&return_to=${zendeskUri}`) :
      window.location.replace(`${environment.zendesk.url}access/jwt?jwt=${token}&return_to=${zendeskUri}`);
  }

  async getToken(): Promise<string> {
    return this.apiService.get<string>('user/zendesk-token').toPromise();
  }

  async initZendeskWidget() {
    console.log('Applying Zendesk Settings')

    window['zE']('webWidget', 'updateSettings', {
      webWidget: {
        authenticate: {
          jwtFn: (callback: (token: string) => {}) => {
            this.getZendeskWidgetToken().then(token => callback(token));
          }
        },
        helpCenter: {
          searchPlaceholder: {
            '*': 'Rechercher dans le centre d\'aide',
          }
        }
      }
    });

    window['zE']('webWidget', 'helpCenter:reauthenticate');
  }

  async getZendeskWidgetToken(): Promise<string> {
    return this.apiService.get<string>('user/zendesk-widget-token').toPromise();
  }

  setSuggestionsBySearch(search: string) {
    window['zE']('webWidget', 'helpCenter:setSuggestions', { search: search });
  }

  setSuggestionsByUrl(url: string) {
    window['zE']('webWidget', 'helpCenter:setSuggestions', { url: url });
  }

  setSuggestionsByLabel(labels: string[]) {
    window['zE']('webWidget', 'helpCenter:setSuggestions', { labels: labels });
  }

  /** Pour les pages configurées, propose les suggestions définies */
  setPageSuggestions(url: string) {
    const label = this.UrlLabels.find(ul => url.includes(ul.url))?.label;

    if (label) {
      this.setSuggestionsByLabel([label]);
      return;
    }

    // Si pas de label défini, on fait en fonction de l'url
    this.setSuggestionsByUrl(url);
  }
}
